<template>
  <div v-if="visible" :class="{ show: loading, element: type !== 'page' }" class="loader-mask">
    <svg
      class="loader"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.0"
      viewBox="0 0 128 128"
      xml:space="preserve"
    >
      <g>
        <circle
          cx="16" cy="64" r="16"
          fill="#ffffff" fill-opacity="1"
        />
        <circle
          cx="16"
          cy="64"
          r="14.344"
          fill="#ffffff"
          fill-opacity="1"
          transform="rotate(45 64 64)"
        />
        <circle
          cx="16"
          cy="64"
          r="12.531"
          fill="#ffffff"
          fill-opacity="1"
          transform="rotate(90 64 64)"
        />
        <circle
          cx="16"
          cy="64"
          r="10.75"
          fill="#ffffff"
          fill-opacity="1"
          transform="rotate(135 64 64)"
        />
        <circle
          cx="16"
          cy="64"
          r="10.063"
          fill="#ffffff"
          fill-opacity="1"
          transform="rotate(180 64 64)"
        />
        <circle
          cx="16"
          cy="64"
          r="8.063"
          fill="#ffffff"
          fill-opacity="1"
          transform="rotate(225 64 64)"
        />
        <circle
          cx="16"
          cy="64"
          r="6.438"
          fill="#ffffff"
          fill-opacity="1"
          transform="rotate(270 64 64)"
        />
        <circle
          cx="16"
          cy="64"
          r="5.375"
          fill="#ffffff"
          fill-opacity="1"
          transform="rotate(315 64 64)"
        />
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64"
          calcMode="discrete"
          dur="720ms"
          repeatCount="indefinite"
        />
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    type: { type: String, default: 'page' },
  },
  data() {
    return {
      loading: true,
      visible: true,
    };
  },
  methods: {
    async start() {
      const timeout = () => new Promise(() => {
        setTimeout(async () => {
          this.loading = true;
        }, 100);
      });
      if (this.visible) {
        await timeout();
      }
    },
    async finish() {
      const timeout = () => new Promise(() => {
        setTimeout(async () => {
          this.loading = false;
        }, 1200);
      });
      await timeout();
      this.visible = false;
    },
  },
};
</script>
<style lang="scss">
.loader-mask {
  opacity: 0;
  transition: all var(--duration);
  visibility: hidden;
  background: var(--true-white);
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9999;

  .loader {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -32px;
    margin-top: -32px;
    z-index: 3;

    circle[fill] {
      fill: var(--brand-dark) !important;
    }

    circle[stroke] {
      stroke: var(--brand-dark) !important;
    }
  }

  &.show {
    opacity: 0.8;
    visibility: visible;
  }

  &.element {
    position: absolute;

    .loader {
      position: absolute;
    }
  }
}
</style>
